module.exports = __webpack_public_path__ + "img/icon_trade-share.e412a38b.svg";